import moment from "moment";
import ActionCellRender from "../../components/actionCellRender";
import { IconPencil, IconTrash } from "@tabler/icons-react";

export const ItemGroupSchema = (cellRender) => {
  return {
    showActionColumn: true,
    columns: [
      {
        field: "name",
        headerName: "Name",
        sortable: true,
      },

      {
        field: "cname",
        headerName: "Chinese name",
        sortable: true,
      },

      {
        field: "description",
        headerName: "Description",
        sortable: true,
      },

      {
        field: "action",
        cellRender: ActionCellRender,
        isAction: true,
        actions: [
          {
            name: "edit",
            icon: IconPencil,
            props: {
              //   color:"red"
            },
          },
          {
            name: "delete",
            icon: IconTrash,
            props: {
              //   color:"red"
            },
          },
        ],
      },
    ],
    searchableFields: ["name"],
  };
};
